import React from "react";
import PatientList from "../components/PatientList";
import { useTranslation } from 'react-i18next';

const App = () => {

  const { t } = useTranslation();

  return (
    <div id="main">

      <div style={{
        backgroundColor: 'white',
        borderColor: 'white',
        borderBlockWidth: 0,
        fontSize: 30,
        padding: 10,
        fontFamily: 'Kanit',
      }}>
        {t('patients_list.topic')}
      </div>
      <div style={{ padding: 10 }} />
      <PatientList />

    </div>
  )
}


export default App;
